import { formSubmitClear, formComplete } from 'actions/forms'
import { getBeneficiaries, getBeneficiaryLockedStatusAndRem } from 'actions/beneficiaries'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const BENEFICIARY_SAVE_REQUEST = 'BENEFICIARY_SAVE_REQUEST'
export const BENEFICIARY_SAVE_ERROR = 'BENEFICIARY_SAVE_ERROR'
export const BENEFICIARY_SAVE_COMPLETE = 'BENEFICIARY_SAVE_COMPLETE'

const saveBeneficiaryRequest = () => ({
  type: BENEFICIARY_SAVE_REQUEST,
})

const saveBeneficiaryError = errors => ({
  error: errors[0].error,
  type: BENEFICIARY_SAVE_ERROR,
})

const saveBeneficiaryComplete = result => ({
  result,
  type: BENEFICIARY_SAVE_COMPLETE,
})

export const addBeneficiary = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveBeneficiaryRequest())
  agent.Beneficiary.create(payload).then((response) => {
    dispatch(saveBeneficiaryComplete(response))
    dispatch(notify('Beneficiary saved'))

    if (redirect) {
      dispatch(getBeneficiaries(payload.employee_id))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving beneficiary, please try again later', 'warning'))
      dispatch(formSubmitClear(formId))
    }
  })
}

export const editBeneficiary = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveBeneficiaryRequest())
  agent.Beneficiary.update(payload).then((response) => {
    dispatch(saveBeneficiaryComplete(response))
    dispatch(notify('Beneficiary saved'))

    if (redirect) {
      dispatch(getBeneficiaries(payload.employee_id))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving beneficiary, please try again later', 'warning'))
      // console.warn('Err <editBeneficiary>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}

export const deleteBeneficiary = payload => (dispatch) => {
  dispatch(saveBeneficiaryRequest())
  agent.Beneficiary.delete(payload).then((response) => {
    dispatch(saveBeneficiaryComplete(response))
    dispatch(notify('Beneficiary deleted'))
    dispatch(getBeneficiaries(payload.employee_id))
    // dispatch(push({ pathname: '/beneficiaries' }))
    // dispatch(goBack)
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error deleting beneficiary, please try again later', 'warning'))
      // console.warn('Err <deleteBeneficiary>: ', description, error)
      dispatch(saveBeneficiaryError(BENEFICIARY_SAVE_ERROR))
    }
  })
}

export const editBeneficiaryNotes = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveBeneficiaryRequest())
  agent.Beneficiary.updatenotes(payload).then((response) => {
    dispatch(saveBeneficiaryComplete(response))
    dispatch(notify('Note successfully added'))

    if (redirect) {
      dispatch(getBeneficiaryLockedStatusAndRem(payload.employee_id))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving beneficiary notes, please try again later', 'warning'))
      // console.warn('Err <editBeneficiaryNotes>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}



// WEBPACK FOOTER //
// ./src/actions/beneficiaryForm.js